import React, { useEffect } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Unstable_Grid2';

import ColorSwatches from './../components/color-swatches'
import InfoTabs from './../components/info-tabs';
import CartButtons from './../components/cart-buttons';
import ProductInfo from './../components/product-info';
import { useCanineCoverStore } from '../stores/canine-cover-store';
import { formatMoney } from '../utils/helpers';

function CanineBeds() {
  const selectedColor = useCanineCoverStore(state => state.selectedColor);
  const setSelectedColor = useCanineCoverStore(state => state.setSelectedColor);
  const productVariant = useCanineCoverStore(state => state.productVariant);
  const setProductVariant = useCanineCoverStore(state => state.setProductVariant);
  const quantity = useCanineCoverStore(state => state.quantity);
  const setQuantity = useCanineCoverStore(state => state.setQuantity);
  const colorGroup = useCanineCoverStore(state => state.colorGroup);
  const tabs = useCanineCoverStore(state => state.tabs);

  const mainImage = selectedColor.images.find(img => img.type === 'main');

  const addToCart = async () => {
    // console.log('addToCart selectedCar', selectedCar);

    if (productVariant?.id && quantity > 0) {

      console.log('productVariant', productVariant);

      const { data } = await axios.post('/cart/add.js', {
        items: [{
          id: productVariant.id,
          quantity
        }]
      });

      // console.log('addToCart data', data);

      window.location.href = encodeURI('/cart');
    }
  }

  const getVariantForOptions = () => {
    const variants = window.conspire_product.variants;

    console.log('selectedColor.name.toLowerCase()', selectedColor.name.toLowerCase());

    const selectedVariant = variants.find(
      v => v.option1.toLowerCase() === selectedColor.name.toLowerCase()
    );

    console.log('selectedVariant', selectedVariant);
    setProductVariant(selectedVariant)
  }

  useEffect(() => {
    getVariantForOptions();
  }, [selectedColor]);

  return (
    <Grid container>
      <Grid item xs={12} md={8} className="mobile-hide">
        <section className="main-image-container">
          <img src={mainImage.imageUrl} alt="" />
        </section>
        <InfoTabs tabs={tabs} />
      </Grid>
      <Grid item xs={12} md={4}>
        <ProductInfo />
        <div className="car-option-price-container">
          {productVariant?.compare_at_price ? (
            <>
              <p className="car-option-price car-option-price-discount">
                {formatMoney(productVariant.price / 100)}
              </p>
              <p className="car-option-price car-option-price-has-discount">
                {formatMoney(productVariant.compare_at_price / 100)}
              </p>
            </>
          ) : (
            <p className="car-option-price">{formatMoney(productVariant.price / 100)}</p>
          )}
        </div>
        <section className="main-image-container desktop-hide">
          <img src={mainImage.imageUrl} alt="" />
        </section>
        <ColorSwatches
          title="Colors"
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          colors={colorGroup.colors}
          showSelectedColor
        />
        <CartButtons addToCart={addToCart} quantity={quantity} setQuantity={setQuantity} />
        <section className="info-tabs-wrapper desktop-hide">
          <InfoTabs tabs={tabs} />
        </section>
      </Grid>
    </Grid>
  )
}

export default CanineBeds
